import { gql } from '@apollo/client';

export const GET_COUNTS = gql`
  query Query($input: PaymentSearchInput) {
  countPayments(input: $input)
}
`;
